import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Purchases from '@componentsV2/Purchases';
import { withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import styles from './style';
import useDashboardLinkPrefix from '../../../../hooks/useDashboardLinkPrefix';

import {
  boligmappaPlusCancel,
  getUserTransactions,
} from '../../../../api/boligmappaPlus';
import {
  getActiveSubscriptions,
  getFormattedTransactionsData,
  getPaidSinglePayments,
} from '../../../../utils/boligmappaPlus';
import useSnackbar from '../../../../hooks/useSnackbar';
import { sGetUserTransactions } from '../../../../store/reducers/userTransactions';
import WithHeader from '../../../../components/layouts/WithHeader';
import matomo from '../../../../utils/matomo';
import useSearchQuery from '../../../../hooks/useSearchQuery';

const PurchasesPage = ({ classes }) => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userTransactions, setUserTransactions] = useState({});
  const dashboardLinkPrefix = useDashboardLinkPrefix();

  const { cancelled } = useSearchQuery();

  const history = useHistory();

  const { showSuccessMessage, showErrorMessage } = useSnackbar();

  const onSubscriptionCancel = async (subId) => {
    const [error, response] = await boligmappaPlusCancel(subId);
    if (!error && response) {
      setTransactions((prevState) =>
        prevState.filter((el) => el.orderNumber !== subId)
      );
      history.push(`/subscription-cancelled?redirect=${dashboardLinkPrefix}`);
      matomo.clickEvent({
        category: 'Boligmappa+',
        action: 'Subscription Cancelled Successfully via request',
      });
    } else {
      showErrorMessage('Noe gikk galt.');
    }
  };

  const fetchStoredUserTransactions = async () => {
    if (userTransactions) {
      const transactionsData = [
        ...getActiveSubscriptions(userTransactions.subscriptions),
        ...getPaidSinglePayments(userTransactions.singlePayments),
      ];

      setTransactions(getFormattedTransactionsData(transactionsData));
      setLoading(false);
    }
  };

  const fetchUserTransactions = async () => {
    const [error, response] = await getUserTransactions();
    if (!error && response) {
      setUserTransactions(response.responses);
    }
  };

  useEffect(() => {
    fetchUserTransactions();
    if (cancelled) {
      showSuccessMessage('Abonnementet er avsluttet!');
      history.replace({ search: '' });
    }
  }, []);

  useEffect(() => {
    fetchStoredUserTransactions();
  }, [userTransactions]);

  return (
    <WithHeader headerTitle="Mine kjøp" noPadding>
      <div className={classes.page}>
        <Purchases
          dashboardLinkPrefix={dashboardLinkPrefix}
          transactions={transactions}
          setTransactions={setTransactions}
          onSubscriptionCancel={onSubscriptionCancel}
          loading={loading}
        />
      </div>
    </WithHeader>
  );
};

const mapStateToProps = (state) => ({
  userTransactions: sGetUserTransactions(state),
});

export default connect(mapStateToProps)(withStyles(styles)(PurchasesPage));
